import { BreadcrumbItem } from '@components/v2/ui/Breadcrumb/breadcrumb.types';
import LangEnum from '../../../../../lang/LangEnum';
import { Catalog } from '../../../catalog.types';
import { CatalogViewCatalogFields } from '../../v2/view/catalogView.types';
import { toCatalogViewCatalogFields } from '../../v2/view/resolveEffectiveView';
import {
  BuildCatalogBreadcrumbItemsParams,
  ResolveCatalogReadModeParams,
} from './useCatalogProductsScreen.types';

export const buildCatalogViewConfig = (catalog?: Catalog): CatalogViewCatalogFields | null =>
  catalog ? toCatalogViewCatalogFields(catalog) : null;

export const buildCatalogBreadcrumbItems = ({
  showCatalogsBreadcrumbNav,
  catalogName,
  goToCatalogList,
}: BuildCatalogBreadcrumbItemsParams): BreadcrumbItem[] => {
  const breadcrumbItems: BreadcrumbItem[] = [];

  if (showCatalogsBreadcrumbNav) {
    breadcrumbItems.push({ label: LangEnum.CATALOGS_TITLE, onClick: goToCatalogList });
  }
  breadcrumbItems.push({ label: catalogName ?? '' });

  return breadcrumbItems;
};

export const resolveCatalogReadMode = ({
  isPublicAccess,
  canEditCatalogs,
  isOfflineMode,
}: ResolveCatalogReadModeParams): boolean => isPublicAccess || !canEditCatalogs || isOfflineMode;
